class adpVerticalNavigationController {
  constructor() {
    this.name = 'adpVerticalNavigation';
  }
}

export default adpVerticalNavigationController;



// WEBPACK FOOTER //
// ./src/app/components/adpVerticalNavigation/adpVerticalNavigation.controller.js